<template>
    <nav class="navbar navbar-expand-lg">
        <router-link to="/" class="navbar-brand" ><img :src="logo" alt="速购快递"></router-link>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="icon icon-menu"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav">
                <li class="nav-item">
                    <router-link to="/" class="nav-link">速购首页</router-link>
                </li> 
                <li class="nav-item dropdown">
                    <router-link to="/product" class="nav-link">我们的服务</router-link>
                    <!-- <a class="nav-link dropdown-toggle" href="javascript:;" data-toggle="dropdown">产品介绍</a>
                    <div class="dropdown-menu">
                        <a class="dropdown-item" href="./product.html">产品介绍1</a>
                        <a class="dropdown-item" href="./product.html">产品介绍2</a>
                    </div> -->
                </li>
                <li class="nav-item">
                    <router-link to="/service" class="nav-link">客户下单</router-link>
                </li>
                <li class="nav-item">
                    <router-link to="/job" class="nav-link">加入我们</router-link>
                </li>
                <li class="nav-item">
                    <router-link to="/news" class="nav-link">新闻中心</router-link>
                </li>
                <!-- <li class="nav-item" >
                    <router-link to="/about" class="nav-link">关于我们</router-link>
                </li> -->
            </ul>
            <div class="font-fz nav-link2">
                <a href="javascript:;" class="font-fz-now"  @click="onSwitchLanguage('t')" v-if="lang == 't'" >繁体</a>
                <a href="javascript:;"  @click="onSwitchLanguage('t')" v-else>繁体</a>
                <a href="javascript:;" class="font-fz-now" @click="onSwitchLanguage('s')" v-if="lang == 's'" >简体</a>
                <a href="javascript:;" class="" @click="onSwitchLanguage('s')" v-else >简体</a>
            </div>
            <div class="user-info">
                <i class="icon icon-user"></i>
                <span></span>
                <router-link to="/login/">快速登录</router-link>
                <!-- <span>/</span>               
                <router-link to="/login/register">注册</router-link> -->
            </div>
        </div>
    </nav>
</template>

<style src="bootstrap/dist/css/bootstrap.min.css"  scoped></style>

<style src="@/assets/css/style.css"  scoped></style>
<script>
// import "@/assets/css/style.css"
// <style src="assets/css/style.css"  scoped></style>


export default{
    name:'App',
    data(){
        var logo = require("@/images/logo.png")
        return{
            logo:logo,
            lang:'t'

        }
    },
    watch:{
        $route(to,from){
            console.log(to);
            console.log(to.path);
        }
    },
	methods: {
        
        onSwitchLanguage(val) {
            this.lang = val
            if(val == 's'){
                localStorage.setItem('lang','s')
            }else{
                localStorage.setItem('lang','t')
            }
            this.$zh_tran(localStorage.getItem('lang'))
        }
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/common/header.vue